import Image from 'next/image';
import { Box, Container, Typography } from '@mui/material';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import Link from 'next/link';
import useIsMobile from 'hooks/useIsMobile';

export default function ProfessionalScientific() {
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <Box className={classes.mainBox}>
      <Container maxWidth="md">
        <Typography className={classes.title}>
          Investing in a professional scientific design is investing in the{' '}
          <span>success of your research communication</span>
        </Typography>

        <Typography className={classes.description}>
          Maximize clarity, capture attention, and <span>propel your scientific discoveries</span>{' '}
          to new heights
        </Typography>

        <Box textAlign="center">
          <Link href={!isMobile ? '#select-type' : '/unsupported-device'}>
            <CustomButton variant="buttonWhiteTextPurple">Request your design</CustomButton>
          </Link>

          <Box display="flex" justifyContent="center" pt={3} gap="10px">
            <Image
              src="/images/people-customers.png"
              alt="people customers"
              width={82}
              height={23}
              loading="lazy"
            />

            <Typography variant="body2" style={{ color: '#fff' }}>
              <b>+20mil</b> customers
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
